import PropTypes from 'prop-types';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';

const MenuLink = ({ children, to, ...props }) => {
  const resolved = useResolvedPath(to);
  const match = useMatch({ path: resolved.pathname, end: true });

  const className = match ? 'active' : '';
  return (
    <Link
      className={className}
      to={to}
      {...props}
    >
      {children}
    </Link>
  );
};

MenuLink.defaultProps = {
  children: null,
};

MenuLink.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string.isRequired,
};

export default MenuLink;
